import { AbstractControl, ValidationErrors } from "@angular/forms";
import { isValidEmail } from "./is-email-validator";

export function validateLoginNew(control: AbstractControl): ValidationErrors | null {

    const { email } = control.value;

    if (!email || !isValidEmail(email))
        return { loginInvalid: true };

    return null;
}